import { format } from 'date-fns'
import { Table, TableScrollHost, Thead, Tbody, Tr, Td, Th } from '@/common/ui/Table'
import { Pagination } from '@/common/ui/Pagination'
import { useTransactions } from '../model'
import { Icon } from '@/common/ui/Icon'
import type { TokenTransactionResponse } from '@/common/api/client/types.gen'

type SpendType = TokenTransactionResponse['spend_type']
type AddType = TokenTransactionResponse['add_type']

type Reference = 'email_verification'
const descriptionMap = (spend_type?: SpendType, add_type?: AddType, reference?: Reference) => {
    if (spend_type) {
        switch (spend_type) {
            case 'manual':
                return 'Ручное начисление'
            case 'refund':
                return 'Возврат токенов'
            case 'generation_card':
                return 'Анализ товара'
            case 'generation_text':
                return 'Генерация текста'
            case 'generation_image':
                return 'Генерация изображения'
            case 'generation_infographic':
                return 'Генерация инфографики'
            case 'generation_description':
                return 'Генерация описания'
            case 'generation_title':
                return 'Генерация заголовка'
            case 'generation_features':
                return 'Генерация характеристик'
            case 'generation_other':
                return 'Другая операция'
        }
    }
    if (add_type) {
        switch (add_type) {
            case 'trial':
                return 'Тrial'
            case 'subscription':
                return 'Подписка'
            case 'subscription_renewal':
                return 'Продление подписки'
            case 'promo_code':
                return 'Промокод'
            case 'additional_purchase':
                return 'Докупка токенов'
            case 'manual':
                return 'Ручное начисление'
            case 'refund':
                return 'Возврат токенов'
        }
    }
    if (reference) {
        switch (reference) {
            case 'email_verification':
                return 'Начисление токенов за регистрацию'
        }
    }
    return 'Неизвестная операция'
}

export const TransactionsTable = () => {
    const { data, isLoading, error, currentPage, totalPages, setCurrentPage } = useTransactions()

    if (isLoading) return <div>Загрузка...</div>
    if (error) return <div>Ошибка: {error.message}</div>

    if (!data) return <div>Нет данных</div>

    return (
        <>
            <TableScrollHost minHeight={false} outline={false}>
                <Table border pinRows pinCols striped thBg>
                    <Thead>
                        <Tr>
                            <Th>Операция</Th>
                            <Th>Дата и время</Th>
                            <Th>Статус</Th>
                            <Th>
                                <span className='whitespace-nowrap inline-flex items-center gap-1'>
                                    <Icon className='inline' name='tokens' size='sm' />
                                    Сумма
                                </span>
                            </Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {data.items.length === 0 ? (
                            <Tr>
                                <Td colSpan={4} className='text-center'>
                                    <p>Нет транзакций</p>
                                </Td>
                            </Tr>
                        ) : (
                            data.items.map((item, index) => (
                                <Tr key={index}>
                                    <Td>
                                        {descriptionMap(
                                            item.spend_type ?? undefined,
                                            item.add_type as AddType | undefined,
                                            item.reference as Reference | undefined
                                        )}
                                    </Td>
                                    <Td>{format(new Date(item.created_at), 'dd.MM.yyyy HH:mm')}</Td>
                                    <Td>{item.source}</Td>
                                    <Td>{item.amount.toLocaleString('ru-RU')}</Td>
                                </Tr>
                            ))
                        )}
                    </Tbody>
                </Table>
            </TableScrollHost>
            <div className='mt-6 text-center'>
                <Pagination currentPage={currentPage} totalPages={totalPages ?? 0} onPageChange={setCurrentPage} />
            </div>
        </>
    )
}
